import { createFileRoute } from "@tanstack/react-router";
import { MockDataPage } from "../../components/system/MockDataPage";
import { requireSuperAdmin } from "../../lib/auth/route-protection";

export const Route = createFileRoute("/system/mock-data")({
  beforeLoad: requireSuperAdmin(),
  component: MockDataPage,
});
